// Lock state helper — query and toggle lock on any object type

import { zoneState } from '@/zones/ZoneState'
import { gardenObjectState } from '@/state/GardenObjectState'

/**
 * Check if an object is locked, regardless of source type.
 */
export function isObjectLocked(sourceType: string, id: string): boolean {
  if (sourceType === 'zone') {
    return zoneState.getZoneById(id)?.locked === true
  }
  if (sourceType === 'pin') {
    return zoneState.getPinById(id)?.locked === true
  }
  if (sourceType === 'boundary') {
    return false // Boundaries cannot be locked
  }
  // groundShape, building, plant
  return gardenObjectState.getObjectById(id)?.locked === true
}

/**
 * Set lock state on an object.
 */
export function setObjectLocked(sourceType: string, id: string, locked: boolean): void {
  if (sourceType === 'zone') {
    zoneState.updateZone(id, { locked })
  } else if (sourceType === 'pin') {
    zoneState.updatePin(id, { locked })
  } else if (sourceType !== 'boundary') {
    gardenObjectState.updateObject(id, { locked })
  }
}
